import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminBrandBannerStatus } from '@web/shared/module/brand';
import { Nillable } from '@web/utils';
import { AdminBrandBannerStatusProviderService } from '../providers/admin-brand-banner-status-provider.service';

@Pipe({
  name: 'adminBrandBannerStatus',
  standalone: true,
})
export class AdminBrandBannerStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminBrandBannerStatusProviderService);

  public transform(
    status: AdminBrandBannerStatus,
  ): Observable<Nillable<string>> {
    return this.provider.labelFor(status);
  }
}
